import React, { useCallback, useRef } from 'react';
import { View, } from 'react-native';
import { useDerivedValue } from 'react-native-reanimated';
import Spacer from 'design-system/Spacer';
import { selectMonthlyCategories } from 'features/analytics/selectors';
import { useSyncMonthlyTotals } from 'features/analytics/hooks/useSyncMonthlyTotals';
import { selectCurrentPaydayRange } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import AnalyticsCarousel from '../AnalyticsCarousel.web';
import AnalyticsControls from '../AnalyticsControls';
import AnalyticsSelector from './AnalyticsSelector';
import AnalyticsCarouselItem from '../AnalyticsCarouselItem';
import PeriodControl from '../PeriodControl.web';
const AnalyticsSectionListHeader = ({ position, positionToBlurFrom, monthlyTotals, filteredMonthlyTotals, contentContainerStyle, setSelection, onLayout, onPressUpgradeForSearch, }) => {
    const currentPaydayRange = useAppSelector(selectCurrentPaydayRange);
    const monthlyCategories = useAppSelector(selectMonthlyCategories);
    const [onEndReached, fetching] = useSyncMonthlyTotals(position);
    const positionRef = useRef(position);
    positionRef.current = position;
    const positionAnimatedValue = useDerivedValue(() => position, [position]);
    const effectiveMonthlyTotalsStep = filteredMonthlyTotals?.step ?? (currentPaydayRange ? 'payperiod' : 'month');
    const renderCarouselItem = useCallback(({ item, index }) => (<View>
        <AnalyticsCarouselItem index={index} positionAnimatedValue={positionAnimatedValue} value={item.value} spending={item.spending} previousSpending={monthlyTotals[index + 1]?.spending} currency={item.currency} income={item.income} monthlyCategories={monthlyCategories[`${item.from}|${item.to}`]} spendingBreakdown={item.spendBreakdown} spendingBreakdownPrevious={monthlyTotals[index + 1]?.spendBreakdown} currentFrom={item.from} currentTo={item.to} previousFrom={monthlyTotals[index + 1]?.from} previousTo={monthlyTotals[index + 1]?.to} monthlyTotalsStep={effectiveMonthlyTotalsStep} blurValue={positionToBlurFrom !== undefined && index >= positionToBlurFrom} onPressUpgradeForSearch={onPressUpgradeForSearch}/>
        <PeriodControl type="analytics" maxDataIndex={monthlyTotals.length - 1}/>
      </View>), [
        effectiveMonthlyTotalsStep,
        positionAnimatedValue,
        monthlyTotals,
        monthlyCategories,
        positionToBlurFrom,
        onPressUpgradeForSearch,
    ]);
    return (<View onLayout={onLayout}>
      <View style={contentContainerStyle}>
        <AnalyticsControls month={monthlyTotals[position]} payPeriod={currentPaydayRange} step={filteredMonthlyTotals?.step} accountIds={filteredMonthlyTotals?.accountIds}/>
        <AnalyticsCarousel type="analytics" data={monthlyTotals} onEndReached={onEndReached} renderItem={renderCarouselItem} isSwitchingTotalsStep={fetching.switchingTotalsStep}/>
        <Spacer.H8 />
        <AnalyticsSelector setSelection={setSelection}/>
      </View>
    </View>);
};
export default AnalyticsSectionListHeader;
